import React from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { useAnalytics } from 'reactfire'

import { LinksWrap } from '../../../Quiz/components/Header/styled'

import { HeaderWrap, IconWrap, DropdownWrap, Button } from './styled'
import { Dropdown } from './components/Dropdown/Dropdown'

import {
  COMPLETE_QUIZ,
  QUIZZES_COMPLETED,
  LEADER_BOARD,
} from 'src/constants/routes'
import { CloseIcon, ThreeDotsIcon } from 'src/components/Icons'
import { breakpoints } from 'src/styles/media'
import { useMedia } from 'src/hooks/useMedia'
import { Modal } from 'src/components/Modal'
import {
  Title,
  Paragraph,
  Button as ModalButton,
  Wrap,
  ColumnWrap,
} from 'src/components/Modal/styled'
import { Connection } from 'src/api/connections/types'
import { removeFriend } from 'src/api/connections/connections'
import { LogoLink } from 'src/components/LogoLink/LogoLink'
import { analyticsEvents } from 'src/constants/analytics/events'

interface Props {
  firstImpressionsOpen: boolean
  closeFirstImpressions: () => void
  otherUser: Connection['otherUser']
}

const Header: React.FC<Props> = ({
  firstImpressionsOpen,
  closeFirstImpressions,
  otherUser,
}) => {
  const { logEvent } = useAnalytics()

  const isDesktop = useMedia(breakpoints.desktop)
  const { search } = useLocation()
  const { push } = useHistory()

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false)
  const [isRemoveFriendModalOpen, setIsRemoveFriendModalOpen] = React.useState(
    false
  )

  const preselectedQuizId = new URLSearchParams(search).get('quizId')

  const handleMobileBack = () => {
    if (!firstImpressionsOpen) {
      push(LEADER_BOARD)
      return
    }
    if (preselectedQuizId) {
      push(COMPLETE_QUIZ.replace(':id', preselectedQuizId))
      return
    }
    closeFirstImpressions()
  }

  const handleRemoveFriend = async () => {
    await removeFriend(otherUser.id)
    logEvent(analyticsEvents.friendshipRemoved)
    push(LEADER_BOARD)
  }

  const desktopBackLink = preselectedQuizId
    ? COMPLETE_QUIZ.replace(':id', preselectedQuizId)
    : QUIZZES_COMPLETED

  return (
    <>
      <HeaderWrap>
        {isDesktop ? (
          <LogoLink />
        ) : (
          <IconWrap onClick={handleMobileBack}>
            <CloseIcon />
          </IconWrap>
        )}
        <LinksWrap>
          <DropdownWrap>
            <Button onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
              <ThreeDotsIcon />
            </Button>
            <Dropdown
              isOpen={isDropdownOpen}
              onClose={() => setIsDropdownOpen(false)}
              openRemoveFriendModal={() => setIsRemoveFriendModalOpen(true)}
            />
          </DropdownWrap>
          {isDesktop && (
            <Link to={desktopBackLink}>
              <CloseIcon />
            </Link>
          )}
        </LinksWrap>
      </HeaderWrap>
      <Modal
        isOpen={isRemoveFriendModalOpen}
        onClose={() => setIsRemoveFriendModalOpen(false)}
      >
        <Wrap>
          <Title>Remove a friend</Title>
          <Paragraph>
            Are you sure you want to
            <br /> unconnect with {otherUser.firstName}?
          </Paragraph>
          <ColumnWrap>
            <ModalButton onClick={handleRemoveFriend}>Remove</ModalButton>
            <ModalButton
              secondary
              onClick={() => setIsRemoveFriendModalOpen(false)}
            >
              Close
            </ModalButton>
          </ColumnWrap>
        </Wrap>
      </Modal>
    </>
  )
}

export default Header
